import { PlanTypes } from "../plan-types";

type SubscriptionLimits = Record<PlanTypes, number>;

export const wordCountLimits: SubscriptionLimits = {
  PERSONAL: 1500,
  CONSULTANT: 8000,
  BUSINESS: 15000,
};

export const reportsCreatedPerMonth: SubscriptionLimits = {
  PERSONAL: 5,
  CONSULTANT: 20,
  BUSINESS: 100,
};

const filesPerReport: SubscriptionLimits = {
  PERSONAL: 5,
  BUSINESS: 10,
  CONSULTANT: 15,
};

const subscriptionLimits = {
  reportsCreated: reportsCreatedPerMonth,
  filesPerReport,
  wordCountLimit: wordCountLimits,
} as const;

interface isAtSubscriptionLimitInput {
  userSubscriptionType: PlanTypes;
  limitType: keyof typeof subscriptionLimits;
  currentCount: number;
}

export const isAtSubscriptionLimit = ({
  userSubscriptionType: subscriptionType,
  limitType,
  currentCount,
}: isAtSubscriptionLimitInput) => {
  const limit = subscriptionLimits[limitType][subscriptionType];

  console.log("limit", limit);

  console.log("currentCount", currentCount);

  return currentCount >= limit;
};

export const isAboveSubscriptionLimit = ({
  userSubscriptionType: subscriptionType,
  limitType,
  currentCount,
}: isAtSubscriptionLimitInput) => {
  const limit = subscriptionLimits[limitType][subscriptionType];

  console.log("limit", limit);

  console.log("currentCount", currentCount);

  return currentCount > limit;
};
